import "./InterviewPage.css";
import { AuthContext } from "../../context/AuthContext";
import { useState, useContext, useEffect } from "react";
import axios from "axios";
import OneCandidate from "../onecandidate/OneCandidate";
import HrOneCandidate from "../hr/hronecandidate/HrOneCandidate";
import { Button, Space, Table, Typography, Tag, Grid } from "antd";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export default function InterviewPage() {
    const { authData, backUrl } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [lno, setLno] = useState(null);
    const [filters, setFilters] = useState({ status: "Scheduled" });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const screens = useBreakpoint();

    const fetchInterviewReq = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/my_interviews/?status=${filters.status}&page=${page}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setData(res.data.results || res.data);
            setTotalPages(res.data.total_pages || 1);
        } catch (error) {
            console.error("Error fetching interviews:", error);
        }
    };

    useEffect(() => {
        fetchInterviewReq();
    }, [filters, page]);

    const handleStatusClick = (status) => {
        setFilters({ status });
        setPage(1);
    };

    const handlePrev = () => {
        if (page > 1) setPage((prev) => prev - 1);
    };

    const handleNext = () => {
        if (page < totalPages) setPage((prev) => prev + 1);
    };

    const columns = [
        {
            title: "Candidate Name",
            dataIndex: "candidate_name",
            key: "candidate_name",
            render: (text, record) => (
                <a
                    style={{
                        cursor: "pointer",
                        color: "#0e497b",
                        wordBreak: "break-word",
                    }}
                    onClick={() => {
                        setSelectedId(record.candidate_id);
                        setLno(record.level_number);
                    }}
                >
                    {text}
                </a>
            ),
        },
        {
            title: "Organisation",
            dataIndex: "requisition_organisation",
            key: "requisition_organisation",
        },
        {
            title: "Department",
            dataIndex: "requisition_department",
            key: "requisition_department",
        },
        {
            title: "Designation",
            dataIndex: "requisition_designation",
            key: "requisition_designation",
        },
        {
            title: "Education Background",
            dataIndex: "education_background",
            key: "education_background",
            render: (text) =>
                text && text.trim() !== "" ? text : "Not Specified",
        },
        {
            title: "Level",
            dataIndex: "level_number",
            key: "level_number",
        },
        {
            title: "Interview Date",
            dataIndex: "interview_date",
            key: "interview_date",
        },
        {
            title: "Interview Time",
            dataIndex: "interview_time",
            key: "interview_time",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
    ];

    return (
        <>
            {selectedId === null ? (
                <div className="interview-container">
                    <div className="count-area mb-5">
                        <Tag
                            className="status-tag"
                            color={filters.status === "Scheduled" ? "blue" : "default"}
                            onClick={() => handleStatusClick("Scheduled")}
                        >
                            <h6>Scheduled</h6>
                        </Tag>

                        {authData?.employee?.is_superuser ? (
                            <Tag
                                className="status-tag"
                                color={filters.status === "Selected" ? "green" : "default"}
                                onClick={() => handleStatusClick("Selected")}
                            >
                                <h6>Selected</h6>
                            </Tag>
                        ) : (
                            <Tag
                                className="status-tag"
                                color={filters.status === "Shortlisted" ? "green" : "default"}
                                onClick={() => handleStatusClick("Shortlisted")}
                            >
                                <h6>Shortlisted</h6>
                            </Tag>
                        )}

                        <Tag
                            className="status-tag"
                            color={filters.status === "Rejected" ? "red" : "default"}
                            onClick={() => handleStatusClick("Rejected")}
                        >
                            <h6>Rejected</h6>
                        </Tag>

                        <Tag
                            className="status-tag"
                            color={filters.status === "On-hold" ? "gray" : "default"}
                            onClick={() => handleStatusClick("On-hold")}
                        >
                            <h6>Hold</h6>
                        </Tag>
                    </div>

                    <div className="table-container">
                        <Table
                            columns={columns}
                            dataSource={data.length > 0 ? data : []}
                            rowKey={(record) =>
                                record.candidate_id || record.key || Math.random()
                            }
                            bordered
                            pagination={false}
                            locale={{
                                emptyText: (
                                    <Text type="secondary">No interviews scheduled.</Text>
                                ),
                            }}
                            scroll={{ x: "max-content" }}
                            style={{ marginTop: 16 }}
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th
                                            {...props}
                                            style={{
                                                backgroundColor: "#0e497b",
                                                color: "white",
                                            }}
                                        />
                                    ),
                                },
                            }}
                        />
                    </div>

                    {/* Pagination Controls */}
                    <div
                        className="pagination-controls"
                        style={{
                            display: "flex",
                            justifyContent: screens.xs ? "center" : "space-between",
                            alignItems: "center",
                            flexDirection: screens.xs ? "column" : "row",
                            gap: screens.xs ? "10px" : "0",
                            marginTop: 16,
                            width: "100%",
                        }}
                    >
                        <Button
                            type="default"
                            onClick={handlePrev}
                            disabled={page === 1}
                            size={screens.xs ? "small" : "middle"}
                            style={{
                                width: screens.xs ? "100%" : "auto",
                                maxWidth: "200px",
                            }}
                        >
                            Previous
                        </Button>

                        <Text
                            style={{
                                fontSize: screens.xs ? "0.9rem" : "1rem",
                                textAlign: "center",
                            }}
                        >
                            Page {page} of {totalPages}
                        </Text>

                        <Button
                            type="default"
                            onClick={handleNext}
                            disabled={page === totalPages}
                            size={screens.xs ? "small" : "middle"}
                            style={{
                                width: screens.xs ? "100%" : "auto",
                                maxWidth: "200px",
                            }}
                        >
                            Next
                        </Button>
                    </div>

                </div>
            ) : authData?.employee?.is_superuser ? (
                <HrOneCandidate
                    id={selectedId}
                    lno={lno}
                    onBack={() => setSelectedId(null)}
                />
            ) : (
                <OneCandidate
                    id={selectedId}
                    lno={lno}
                    onBack={() => setSelectedId(null)}
                />
            )}
        </>
    );
}
